import * as Colors from "../../../../../globalStyles/environmentColors";

export const body = {
    padding: "30px"
};

export const tabText = {
    textAlign: "center",
    fontWeight: "bold",
    color: Colors.primary,
    cursor: "pointer"
};

export const tabSelectedText = {
    textAlign: "center",
    fontWeight: "bold",
    color: Colors.primary,
    borderBottom: "4px solid"
};

export const tabBody = {
    paddingTop: "30px"
};

export const editorWrapper = {
    backgroundColor: "white",
    width: "100%"
};

export const editorStyle = {
    minHeight: "250px",
    maxHeight: "250px",
    overflowY: "scroll",
    cursor: "text"
};

export const saveBtn = {
    textAlign: "right"
};

export const dateLabel = {
    margin: "auto"
};

export const newDateLabel = {
    textAlign: "right",
    margin: "auto"
};
